import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { authGuard } from './core/auth/guard/auth.guard';

const routes: Routes = [
  // Default redirect
  { path: '', redirectTo: '/home', pathMatch: 'full' },

  // Protected routes (lazy loaded + authGuard)
  {
    path: 'home',
    loadChildren: () => import('./pages/home/home.module').then((m) => m.HomeModule),
    canActivate: [authGuard],
  },
  {
    path: 'feature',
    loadChildren: () => import('./features/feature/feature.module').then((m) => m.FeatureModule),
    canActivate: [authGuard],
  },

  // Auth routes are handled by AuthRoutingModule (eager loaded via AuthModule)

  // Wildcard
  { path: '**', redirectTo: '/home' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
